import * as React from "react";
import { Alert } from "react-bootstrap";

export default () => (
  <Alert bsStyle="info">
    <strong>Questions?</strong>
    <div>
      Contact us at <a href="mailto:info@acp-usa.org"> info@acp-usa.org </a>
      <span style={{ whiteSpace: "nowrap" }}>or (212) 752-0700.</span>
    </div>
  </Alert>
);
